import { getOrNull } from '../request';
import { APP_CONFIG } from '@/config';
import type { TenantNetworkListing } from '@/@types/tenantNetwork';

export const getTenantNetworkListing = async (propertyHubId: string): Promise<TenantNetworkListing | null> => {
  return await getOrNull<TenantNetworkListing>(
    `${APP_CONFIG.tenantNetworkApiUrl}/listings/property-hub/${propertyHubId}`,
  );
};
